import Content from "../components/layout/content/Content";

function Main() {
  return (
    <>
      <Content />
    </>
   
  );
}

export default Main;
